import React from 'react';

import { formatSessionDateTime, formatSessionPlace } from '../../lib/helpers/assessment-session.helpers';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { getMessages } from './assessment-session-summary.messages';

interface IAssessmentSessionSummaryProps {
  session: IAssessmentSessionSummary;
}

// Names *which* ice time a record refers to, in one line: the sport-termed
// label, the date/time span, then the venue.
export const AssessmentSessionSummary: React.FC<IAssessmentSessionSummaryProps> = ({ session }) => {
  const messages = getMessages(useCompanySportTerminology());

  // Falls back to the address so an ice time with neither venue nor area is
  // still identifiable — `address` is required on the session.
  const place = formatSessionPlace(session) || session.address;

  return (
    <>
      <IntlMsg
        {...messages.summary}
        values={{ when: formatSessionDateTime(session.date, session.start, session.duration, true) }}
      />
      {place && <> • {place}</>}
    </>
  );
};
